import React from 'react';
import LoadingSpinner from './loadingSpinner'
import {wsTrans} from '../utils/utils'
import {cl,globs,getTime} from '../../components/utils/utils';
import {lastWsData00,} from '../../components/utils/ws';

const boxStyle = {
  padding: 10,
  borderRadius: 10,
  border: '1px solid #CCCCCC',
};

class C18MassOta extends React.Component {
  constructor(props) {
    super(props);
//     cl(props)
    this.state = {
      loaded: false,
      firmwares: [],
      selAccount: '',
      searchAccount: '',
      accountOpen: false,
      selSite: '',
      searchSite: '',
      siteOpen: false,
      checkedZones: {},
      selFirmware: '',
    };
    this.accountRef = React.createRef();
    this.siteRef = React.createRef();
  }

  componentDidMount(){
    window.addEventListener('beforeunload', this.savePage);
    document.addEventListener('mousedown', this.onDocMouseDown);
    this.subscribe_toClient=globs.events.subscribe("toClient",this.toClient)
    this.loadInfo()
  }

  componentWillUnmount=()=>{
    cl("component will unmount")
    window.removeEventListener('beforeunload', this.savePage);
    document.removeEventListener('mousedown', this.onDocMouseDown);
    this.subscribe_toClient.remove()
  }

  onDocMouseDown = (e) => {
    if (this.accountRef.current && !this.accountRef.current.contains(e.target)) {
      if (this.state.accountOpen) {
        this.setState({ accountOpen: false, searchAccount: '' });
      }
    }
    if (this.siteRef.current && !this.siteRef.current.contains(e.target)) {
      if (this.state.siteOpen) {
        this.setState({ siteOpen: false, searchSite: '' });
      }
    }
  }

  showUpdateTime=(gatewayId)=>{
    if(!this.updInts){this.updInts={}}
    this.updInts[gatewayId]={
      elapsed:0,
      int:setInterval(x=>{
        this.updGwStatus(gatewayId,
          `Reset ${this.updInts[gatewayId].elapsed++}s ago`)
      },1000),
    }
  }

  tcOtaMsg=(msg)=>{
    clearTimeout(this.updInts?.[msg.data.gwId]?.int)
    switch(msg.data.type){
      case "start":
      case "calcCrc":
//       case "update":
      case "online":
        this.updGwStatus(msg.data.gwId,msg.data.type)
        this.setState({rtd37:1e4,rtd39:1e4})
        break
      case "prog":
        this.updGwStatus(msg.data.gwId,`Prog ${msg.data.val}%`)
        break
      case "gotCrc":
        this.updGwStatus(msg.data.gwId,`CRC ${(msg.data.val)?"OK":"Fail"}`)
        setTimeout(x=>{this.updGwStatus(msg.data.gwId,"done")},5000)
        break
      case "update":
//         this.updGwStatus(msg.data.gwId,`Prog ${msg.data.val}`)
        return this.showUpdateTime(msg.data.gwId)
      case "rtd":
        this.updGwStatus(msg.data.gwId,`Update ${(msg.data.val)?"OK":"Fail"}`)
        setTimeout(x=>this.showRtd(msg),1000)
        break
    }
  }

  showRtd=(msg)=>{
    let {rtd37,rtd39}=this.state
    cl(msg)
    cl(rtd37,rtd39)
    var showVal=(val)=>{return (+val==1e4)?"--":val}
    let str=`${showVal(rtd37)}\u00B0, ${showVal(rtd39)}%`
    this.updGwStatus(msg.data.gwId,str)
  }

  tcOtaRtd=(msg)=>{
    let id=`rtd${msg.data.id}`
    this.setState({[id]:msg.data.d})
  }

  toClient=(msg,data)=>{
    cl(msg)
    switch(msg.type){
      case "otaMsg":
        return this.tcOtaMsg(msg)
      case "ofuGotRtd":
        return this.tcOtaRtd(msg)
      default:
        break
    }
  }


  loadFirmwares=async()=>{
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/dirList", method: "retrieve",
      sessionId: globs.userData.session.sessionId, body:{
        type:"fwImages",
      }
    })
//     cl(res)
    return res.data.filter(
      r=>{return (r.indexOf("_Menu")<0)&&(r!="cfg")&&(r[0]!=".")&&(r[1]!="B")&&(r[2]=="_")}
    )
  }

  loadInfo=async()=>{
    let fw=await this.loadFirmwares()
//     cl(fw)
    this.setState({
      loaded: true,
      firmwares: Array.isArray(fw) ? fw : [],
      selFirmware: Array.isArray(fw) && fw.length ? fw[0] : '',
    })
  }

  savePage=()=>{
    cl("savePage")
  }

  getAccounts = () => {
    const accounts = Array.isArray(this.props.accounts) ? this.props.accounts : [];
    return accounts
      .filter((a) => a.name && String(a.name).trim())
      .sort((a, b) => {
        return (a.name || '').localeCompare(b.name || '');
      });
  }

  getAccountName = (accountId) => {
    if (!accountId) {
      return '';
    }
    const account = this.getAccounts().find((a) => a.accountId === accountId);
    return account ? account.name : '';
  }

  getSites = () => {
    const sites = Array.isArray(this.props.sites) ? this.props.sites : [];
    const { selAccount } = this.state;
    let filtered = sites.filter((s) => s.name && String(s.name).trim());
    if (selAccount) {
      filtered = filtered.filter((s) => s.accountId === selAccount);
    }
    return [...filtered].sort((a, b) => {
      return (a.name || '').localeCompare(b.name || '');
    });
  }

  getSiteName = (siteId) => {
    if (!siteId) {
      return '';
    }
    const sites = Array.isArray(this.props.sites) ? this.props.sites : [];
    const site = sites.find((s) => s.siteId === siteId);
    return site ? site.name : '';
  }

  getGatewayFwVersion = (gatewayId) => {
    const gateways = Array.isArray(this.props.gateways) ? this.props.gateways : [];
    const gateway = gateways.find((g) => g.gatewayId === gatewayId);
    return gateway && gateway.fwVersion ? gateway.fwVersion : '';
  }

  getZonesForSite = () => {
    const { selSite } = this.state;
    if (!selSite) {
      return [];
    }
    const zones = Array.isArray(this.props.zones) ? this.props.zones : [];
    return zones.filter((z) => {
      return z.siteId === selSite && z.zoneName && String(z.zoneName).trim();
    });
  }

  truncateName = (value) => {
    const name = value == null ? '' : String(value);
    if (name.length <= 20) {
      return name;
    }
    return `${name.slice(0, 20)}...`;
  }

  getDownloadStatusRows = () => {
//     cl(this.props)
    const gateways = Array.isArray(this.props.gateways) ? this.props.gateways : [];
    const zones = Array.isArray(this.props.zones) ? this.props.zones : [];
    const sites = Array.isArray(this.props.sites) ? this.props.sites : [];
    const accounts = Array.isArray(this.props.accounts) ? this.props.accounts : [];

    return gateways
      .filter((g) => g.otaUpdateFile)
      .map((gateway) => {
//         cl(gateway)
        const zone = zones.find((z) => z.gatewayId === gateway.gatewayId);
        const siteId = (zone && zone.siteId) || gateway.siteId;
        const site = sites.find((s) => s.siteId === siteId);
        const accountId = (site && site.accountId) || gateway.accountId ||
          (zone && zone.accountId);
        const account = accounts.find((a) => a.accountId === accountId);

        return {
          gatewayId: gateway.gatewayId,
          account: this.truncateName(account && account.name),
          site: this.truncateName(site && site.name),
          zone: this.truncateName(zone && zone.zoneName),
          status: gateway.otaUpdateStatus || '',
          canUpdate: gateway.otaUpdateStatus === 'done',
          newFw:this.fnToFw(gateway.otaUpdateFile),
          oldFw:gateway.fwVersion,
        };
      });
  }

  openAccountSelect = () => {
    this.setState({
      accountOpen: true,
      searchAccount: '',
      siteOpen: false,
      searchSite: '',
    });
  }

  openSiteSelect = () => {
    this.setState({
      siteOpen: true,
      searchSite: '',
      accountOpen: false,
      searchAccount: '',
    });
  }

  onSelectAccount = (accountId) => {
    const { selSite } = this.state;
    const sites = Array.isArray(this.props.sites) ? this.props.sites : [];
    const currentSite = sites.find((s) => s.siteId === selSite);
    const siteMatches = currentSite && currentSite.accountId === accountId;
    this.setState({
      selAccount: accountId,
      accountOpen: false,
      searchAccount: '',
      selSite: siteMatches ? selSite : '',
      checkedZones: siteMatches ? this.state.checkedZones : {},
    });
  }

  onSelectSite = (siteId) => {
    const sites = Array.isArray(this.props.sites) ? this.props.sites : [];
    const site = sites.find((s) => s.siteId === siteId);
    this.setState({
      selSite: siteId,
      siteOpen: false,
      searchSite: '',
      selAccount: site && site.accountId ? site.accountId : this.state.selAccount,
//       checkedZones: {},
    });
//     this.checkZones()
  }

  checkZone = (zoneId, checked) => {
    this.setState((prev) => ({
      checkedZones: {
        ...prev.checkedZones,
        [zoneId]: checked,
      },
    }));
    let {zones}=this.props
    let {selFirmware}=this.state
    let zone=zones.find(z=>z.zoneId==zoneId)
    this.updGwField(zone.gatewayId,"otaUpdateFile",(checked)?selFirmware:"")
  }

  fnToFw=(fileName)=>{
//PA_Dbg_v1.17.1011_b7853.bin
//     fileName=fileName.replaceAll("-","_")
    let parts=fileName.replaceAll("-","_").split("_")
    for(let p of parts){
      let st=(p[0]=="v")?1:0
      if(st||!isNaN(p[0])){
        return p.replace(".bin","").substring(st)
      }
    }
  }

  downloadFirmware = async () => {
    cl("downloadFirmware")
    let {selFirmware,checkedZones}=this.state
    let {zones}=this.props
    let newFw=this.fnToFw(selFirmware)
    for(let zoneId of Object.keys(checkedZones)) {
      if(checkedZones[zoneId]){
        let zone=zones.find(z=>z.zoneId==zoneId)
        if(zone){
          let upd={
            gatewayId:zone.gatewayId,
            otaNewFw:newFw,
            otaDlTs:getTime(),
            otaUpdateStatus:"pending",
            otaUpdateFile:selFirmware,
            otaUpdateRetry:0,
            otaToClientGw:lastWsData00.gw,// used to send toClient messages
          }
          await wsTrans("usa", {cmd: "cRest", uri: "/su/allGateways",
            method: "update", sessionId: globs.userData.session.sessionId,
            body: upd})
        }
      }
    }
  }

  updGwField=(gatewayId,field,val)=>{
    let {gateways,onChange}=this.props
    let gateways0=gateways.slice(0)
    let gwInfo=gateways0.find(gw=>gw.gatewayId==gatewayId)
    if(!gwInfo){return}
    gwInfo[field]=val
//     gwInfo.otaUpdateStatus=status
    onChange({type:"updGateways",gateways:gateways0})
  }

  updGwStatus=(gatewayId,status)=>{
    this.updGwField(gatewayId,"otaUpdateStatus",status)
//     let {gateways,onChange}=this.props
// //     cl(gatewayId,status)
//     let gateways0=gateways.slice(0)
//     let gwInfo=gateways0.find(gw=>gw.gatewayId==gatewayId)
//     gwInfo.otaUpdateStatus=status
// //     cl(gwInfo)
//     onChange({type:"updGateways",gateways:gateways0})
  }

  selFirmware=(e)=>{
    let {checkedZones}=this.state
    let {zones,gateways,onChange}=this.props
    let gateways0=gateways.slice(0)
    let selFirmware=e.target.value
    this.setState({selFirmware})
    Object.keys(checkedZones).forEach(z0=>{
      let zone=zones.find(z=>z.zoneId==z0)
      let gw=gateways.find(gw=>gw.gatewayId==zone.gatewayId)
      gw.otaUpdateFile=selFirmware
    })
    onChange({type:"updGateways",gateways:gateways0})
  }

//   checkZones=()=>{// mark zones in download status
//
//   }

  clearFailed = async () => {
    let {onChange,gateways}=this.props
    let gateways0=gateways.slice(0)
    let otaGw=gateways0.filter(gw=>gw.otaUpdateFile)
    for(let gw of otaGw){
//       if(true||gw.otaUpdateStatus!="done"){// unmark *all*
        let upd={
          gatewayId:gw.gatewayId,
          otaUpdateFile:null,
          otaUpdateStatus:null,
        }
        await wsTrans("usa", {cmd: "cRest", uri: "/su/allGateways",
          method: "update", sessionId: globs.userData.session.sessionId,
          body: upd})
        gw.otaUpdateFile=null
        gw.otaUpdateStatus=null
//       }
    }
    cl(otaGw)
    cl("clearFailed")
    cl(this.state)
    cl(this.props)
    onChange({type:"updGateways",gateways:gateways0})
    this.setState({checkedZones:[]})
  }

  updateGw = (gatewayId) => {
    void gatewayId;
    let {gateways}=this.props
    let gw=gateways.find(gw=>gw.gatewayId==gatewayId)
    cl(gw)
    // TODO: trigger gateway firmware update
    cl("updateGw")
    cl(gatewayId)
    let query={gatewayId:gatewayId,
      cmd:"otaFlashUpdate",
      offset:0,
      forceFdr:0,
      fwSel:gw.otaUpdateFile,
    }
    cl(query)
    wsTrans("usa", {cmd: "cRest", uri: "/s/controller", method: "update",
      sessionId: globs.userData.session.sessionId, body:
      query})
  }

  renderSearchSelect = ({
    label,
    placeholder,
    open,
    searchValue,
    selectedId,
    selectedLabel,
    options,
    onOpen,
    onSearchChange,
    onSelect,
    rootRef,
  }) => {
    const displayValue = open ? searchValue : selectedLabel;
    const query = (searchValue || '').toLowerCase();
    const filtered = open
      ? options.filter((opt) => (opt.label || '').toLowerCase().includes(query))
      : [];

    return (
      <div style={{ marginBottom: 12 }}>
        <label style={{ display: 'block', marginBottom: 4 }}>{label}</label>
        <div ref={rootRef} style={{ position: 'relative', maxWidth: 360 }}>
          <input
            type="text"
            value={displayValue}
            placeholder={placeholder}
            readOnly={!open}
            onFocus={onOpen}
            onClick={onOpen}
            onChange={(e) => {
              if (open) {
                onSearchChange(e.target.value);
              }
            }}
            style={{
              ...boxStyle,
              width: '100%',
              boxSizing: 'border-box',
              paddingRight: 36,
              cursor: open ? 'text' : 'pointer',
            }}
          />
          <span
            aria-hidden="true"
            style={{
              position: 'absolute',
              right: 10,
              top: '50%',
              transform: 'translateY(-50%)',
              pointerEvents: 'none',
              color: '#666',
              lineHeight: 1,
              fontSize: 18,
            }}
          >
            <span className="material-icons" style={{ fontSize: 20 }}>
              keyboard_arrow_down
            </span>
          </span>
          {open && (
            <div
              style={{
                ...boxStyle,
                position: 'absolute',
                left: 0,
                right: 0,
                top: '100%',
                marginTop: 2,
                maxHeight: 200,
                overflowY: 'auto',
                background: '#FFFFFF',
                zIndex: 10,
                padding: 0,
              }}
            >
              {filtered.length === 0 ? (
                <div style={{ color: '#666' }}>No matches</div>
              ) : (
                filtered.map((opt) => (
                  <div
                    key={opt.value}
                    style={{
                      cursor: 'pointer',
                      background: opt.value === selectedId ? '#C0E0FF' : undefined,
                    }}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => { onSelect(opt.value); }}
                  >
                    {opt.label}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    );
  }

  renderAccountSelect = () => {
    const { selAccount, searchAccount, accountOpen } = this.state;
    const options = this.getAccounts().map((a) => ({
      value: a.accountId,
      label: a.name,
    }));

    return this.renderSearchSelect({
      label: 'Accounts',
      placeholder: 'Select an Account',
      open: accountOpen,
      searchValue: searchAccount,
      selectedId: selAccount,
      selectedLabel: this.getAccountName(selAccount),
      options,
      onOpen: this.openAccountSelect,
      onSearchChange: (value) => { this.setState({ searchAccount: value }); },
      onSelect: this.onSelectAccount,
      rootRef: this.accountRef,
    });
  }

  renderSiteSelect = () => {
    const { selSite, searchSite, siteOpen } = this.state;
    const options = this.getSites().map((s) => ({
      value: s.siteId,
      label: s.name,
    }));

    return this.renderSearchSelect({
      label: 'Sites',
      placeholder: 'Select a Site',
      open: siteOpen,
      searchValue: searchSite,
      selectedId: selSite,
      selectedLabel: this.getSiteName(selSite),
      options,
      onOpen: this.openSiteSelect,
      onSearchChange: (value) => { this.setState({ searchSite: value }); },
      onSelect: this.onSelectSite,
      rootRef: this.siteRef,
    });
  }

  renderZonesTable = () => {
    const { selSite, checkedZones } = this.state;
    const { gateways } = this.props
    const zones = this.getZonesForSite();

    return (
      <div style={{ marginBottom: 12 }}>
        <div style={{ fontWeight: 'bold', marginBottom: 4 }}>Zones</div>
        <div
          style={{
            ...boxStyle,
            maxHeight: 200,
            overflowY: 'auto',
            maxWidth: 560,
          }}
        >
          {!selSite ? (
            <div style={{ color: '#666' }}>Select a site to view zones</div>
          ) : (
            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', padding: '4px 8px', width: 40 }} />
                  <th style={{ textAlign: 'left', padding: '4px 8px' }}>Zone</th>
                  <th style={{ textAlign: 'left', padding: '4px 8px' }}>FW Version</th>
                </tr>
              </thead>
              <tbody>
                {zones.map((zone) => {
                  const checked = Boolean(checkedZones[zone.zoneId]);
//                   cl(zone)
                  let gw=gateways.find(g=>g.gatewayId==zone.gatewayId)
//                   cl(gw)
                  let showCheck=/*(!["Succeeded","done"].includes(gw?.otaUpdateStatus))&&*/
                    true||!gw?.otaUpdateFile
//                   cl(gw)
                  return (
                    <tr key={zone.zoneId}>
                      <td style={{ padding: '4px 8px' }}>
                        {showCheck&&
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={(e) => {
                              this.checkZone(zone.zoneId, e.target.checked);
                            }}
                          />
                        }
                      </td>
                      <td style={{ padding: '4px 8px' }}>{zone.zoneName}</td>
                      <td style={{ padding: '4px 8px' }}>
                        {this.getGatewayFwVersion(zone.gatewayId)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }

  renderFirmwareSelect = () => {
    const { firmwares, selFirmware } = this.state;

    return (
      <div style={{ marginBottom: 12 }}>
        <label style={{ display: 'block', marginBottom: 4 }} htmlFor="c18-mass-ota-firmware">
          Firmware to Download
        </label>
        <select
          id="c18-mass-ota-firmware"
          value={selFirmware}
          onChange={this.selFirmware}
          style={{ ...boxStyle, minWidth: 360 }}
        >
          {firmwares.map((fw) => (
            <option key={fw} value={fw}>{fw}</option>
          ))}
        </select>
      </div>
    );
  }

  renderDownloadButton = () => {
    return (
      <div style={{ marginBottom: 12 }}>
        <button
          type="button"
          onClick={this.downloadFirmware}
          style={{
            ...boxStyle,
            color: '#FFFFFF',
            background: '#4090E0',
            cursor: 'pointer',
            fontWeight:700,
          }}
        >
          Download
        </button>
      </div>
    );
  }

  renderDownloadStatusTable = () => {
    const rows = this.getDownloadStatusRows();
//     cl(rows)
    if (!rows.length) {
      return null;
    }

    return (
      <div style={{ marginBottom: 12 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'baseline',
            marginBottom: 4,
            gap: 12,
          }}
        >
          <div style={{ fontWeight: 'bold' }}>Download Status</div>
          <button
            type="button"
            onClick={this.clearFailed}
            style={{
              ...boxStyle,
              color: '#FFFFFF',
              background: '#4090E0',
              cursor: 'pointer',
              fontWeight: 700,
            }}
          >
            Clear Old
          </button>
        </div>
        <div
          style={{
            ...boxStyle,
            maxHeight: 200,
            overflowY: 'auto',
            maxWidth: 1000,
          }}
        >
          <table style={{ borderCollapse: 'collapse', width: '100%' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', padding: '4px 8px', width: 70 }} />
                <th style={{ textAlign: 'left', padding: '4px 8px' }}>Account</th>
                <th style={{ textAlign: 'left', padding: '4px 8px' }}>Site</th>
                <th style={{ textAlign: 'left', padding: '4px 8px' }}>Zone</th>
                <th style={{ textAlign: 'left', padding: '4px 8px' }}>Current FW</th>
                <th style={{ textAlign: 'left', padding: '4px 8px' }}>New FW</th>
                <th style={{ textAlign: 'left', padding: '4px 8px' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.gatewayId}>
                  <td style={{ padding: '4px 8px' }}>
                    {row.canUpdate ? (
                      <span
                        style={{ color: '#004080', cursor: 'pointer' }}
                        onClick={() => { this.updateGw(row.gatewayId); }}
                      >
                        Update
                      </span>
                    ) : null}
                  </td>
                  <td style={{ padding: '4px 8px' }}>{row.account}</td>
                  <td style={{ padding: '4px 8px' }}>{row.site}</td>
                  <td style={{ padding: '4px 8px' }}>{row.zone}</td>
                  <td style={{ padding: '4px 8px' }}>{row.oldFw}</td>
                  <td style={{ padding: '4px 8px' }}>{row.newFw}</td>
                  <td style={{ padding: '4px 8px' }}>{row.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  showMassOta=()=>{
    return(
      <div style={{ padding: 16 }}>
        {this.renderDownloadStatusTable()}
        {this.renderAccountSelect()}
        {this.renderSiteSelect()}
        {this.renderZonesTable()}
        {this.renderFirmwareSelect()}
        {this.renderDownloadButton()}
      </div>
    )
  }

  render() {
    if(this.state.loaded){
      return this.showMassOta()
    } else{
      return <LoadingSpinner message="Loading..." />
    }
  }

}

export default C18MassOta;
